import { type DiffKey, type DiffValue } from './types'

/**
 * 比較列のキーを取得します。
 *
 * @template T - 比較列値の型。
 * @param diff - 比較列。
 * @returns 比較列のキー。
 */
export function getDiffKey<T extends string>(diff: DiffValue<T>) {
  const [left, right] = diff

  return `${left}vs${right}` as const satisfies DiffKey<T>
}
